"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "JobsProcessor", {
    enumerable: true,
    get: function() {
        return JobsProcessor;
    }
});
const _bull = require("@nestjs/bull");
const _common = require("@nestjs/common");
const _bull1 = require("bull");
const _nocodbsdk = require("nocodb-sdk");
const _Jobs = require("~/interface/Jobs");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
const _jobsmapservice = require("~/modules/jobs/jobs-map.service");
const _jobseventservice = require("~/modules/jobs/jobs-event.service");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
var _process_env_NC_WORKER_CONCURRENCY;
const NC_WORKER_CONCURRENCY = (_process_env_NC_WORKER_CONCURRENCY = process.env.NC_WORKER_CONCURRENCY) != null ? _process_env_NC_WORKER_CONCURRENCY : 10;
const LOCAL_CONCURRENCY_LIMIT = {
    [_Jobs.JobTypes.AtImport]: 2,
    [_Jobs.JobTypes.ThumbnailGenerator]: 1,
    [_Jobs.JobTypes.AttachmentUrlUpload]: 1
};
const LOCAL_JOB_COUNT_MAP = new Map();
let JobsProcessor = class JobsProcessor {
    async process(job) {
        var _job_data;
        const { jobName } = job.data;
        if (!this.jobsMap.jobs[jobName]) {
            this.logger.error(`Job not found for ${jobName}`);
            await this.requeue(job);
            return;
        }
        const { this: processor, fn = 'job' } = this.jobsMap.jobs[jobName];
        if (!processor[fn]) {
            this.logger.error(`Job function not found for ${jobName}`);
            await this.requeue(job);
            return;
        }
        if (_Jobs.JobVersions[jobName] || ((_job_data = job.data) == null ? void 0 : _job_data._jobVersion)) {
            if (_Jobs.JobVersions[jobName] !== job.data._jobVersion) {
                this.logger.error(`Job version mismatch for ${jobName}`);
                await this.requeue(job);
                return;
            }
        }
        const localRunning = LOCAL_JOB_COUNT_MAP.get(jobName);
        if (localRunning && localRunning >= LOCAL_CONCURRENCY_LIMIT[jobName]) {
            job.data._jobDelay = 0;
            job.data._jobAttempt = 1;
            await this.requeue(job);
            return;
        }
        if (localRunning) {
            LOCAL_JOB_COUNT_MAP.set(jobName, localRunning + 1);
        } else {
            LOCAL_JOB_COUNT_MAP.set(jobName, 1);
        }
        let warningTime = 1;
        const longProcessWarning = _nocodbsdk.Timer.start(async (timer)=>{
            this.logger.log(`Job '${job.id}' is taking ${warningTime++ * 10} minutes and stil processing`);
            if (warningTime <= 2) {
                timer.start();
            }
        }, 10 * 60 * 1000);
        try {
            const result = await processor[fn](job);
            return result;
        } catch (e) {
            this.logger.error(`Error processing job ${jobName}`, e);
            throw e;
        } finally{
            const localRunning = LOCAL_JOB_COUNT_MAP.get(jobName);
            LOCAL_JOB_COUNT_MAP.set(jobName, localRunning - 1);
            longProcessWarning.stop();
        }
    }
    async requeue(job) {
        var _ref, _ref1;
        var _job_data, _job_data1;
        // Remove the job from the queue otherwise ids will clash
        await job.releaseLock();
        await job.remove();
        await this.jobsEventService.onCompleted(job, _Jobs.JobStatus.REQUEUED);
        const _jobDelay = (_ref = (_job_data = job.data) == null ? void 0 : _job_data._jobDelay) != null ? _ref : 0;
        const _jobAttempt = (_ref1 = (_job_data1 = job.data) == null ? void 0 : _job_data1._jobAttempt) != null ? _ref1 : 1;
        if (_jobAttempt > _Jobs.JOB_REQUEUE_LIMIT) {
            this.logger.error(`Job ${job.data.jobName} failed after 10 attempts`);
            return;
        }
        job.data._jobDelay = _jobDelay + 5000;
        job.data._jobAttempt = _jobAttempt + 1;
        return this.jobsService.add(job.data.jobName, job.data, {
            jobId: job.id.toString(),
            delay: job.data._jobDelay
        });
    }
    constructor(jobsService, jobsEventService, jobsMap){
        this.jobsService = jobsService;
        this.jobsEventService = jobsEventService;
        this.jobsMap = jobsMap;
        this.logger = new _common.Logger(JobsProcessor.name);
    }
};
_ts_decorate([
    (0, _bull.Process)({
        concurrency: +NC_WORKER_CONCURRENCY
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _bull1.Job === "undefined" ? Object : _bull1.Job
    ]),
    _ts_metadata("design:returntype", Promise)
], JobsProcessor.prototype, "process", null);
JobsProcessor = _ts_decorate([
    (0, _bull.Processor)(_Jobs.JOBS_QUEUE),
    _ts_param(0, (0, _common.Inject)('JobsService')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService,
        typeof _jobseventservice.JobsEventService === "undefined" ? Object : _jobseventservice.JobsEventService,
        typeof _jobsmapservice.JobsMap === "undefined" ? Object : _jobsmapservice.JobsMap
    ])
], JobsProcessor);
